// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24zz5","questions":"styles_questions__1Kgwz","footer":"styles_footer__19yDL"};